import { useState, useRef, useLayoutEffect } from 'react';

export function useResizeObserver() {
    const [height, setHeight] = useState(0);
    const ref = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const observer = new ResizeObserver(entries => {
            if (!Array.isArray(entries)) {
                return;
            }
            if (!entries.length) {
                return;
            }
            const entry = entries[0];
            setHeight(entry.contentRect.height);
        });

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, []);

    return [ref, height] as const;
}
